<div class="d-flex flex-row {{ classList }}" *transloco="let t">
  <div *ngIf="label" class="pe-3">{{ label }}</div>

  <div [classList]="groupClasslist" role="group">
    <a
      class="btn btn-outline-primary text-nowrap {{ btnClasslist }} {{ viewType }}"
      *ngFor="let item of items"
      [class.active]="activeItem?.value === item.value"
      [class.disabled]="isDisabled"
      (click)="onClick(item)"
    >
      {{ t(item.label) }}
    </a>
  </div>
</div>
